<template>
  <basic-dialog :show="show" @close="$emit('close')">
    <template v-slot:title>{{ editorTitle }}</template>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-tabs v-model="tab" centered>
      <v-tab key="details">Details</v-tab>
      <v-tab key="contents">Contents</v-tab>
      <v-tab key="payment-terms">Payment Terms</v-tab>
      <v-tab-item key="details">
        <v-row>
          <v-col>
            <v-text-field
              label="Brand Name"
              v-model="name"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-switch label="Not In Use" v-model="notInUse"></v-switch>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item key="contents">
        <template v-if="value && value.id">
          <contents owner-name="BRAND" :owner-id="value.id" />
        </template>
      </v-tab-item>
      <v-tab-item key="payment-terms">
        <v-row>
          <v-col>
            <payment-terms :owner-id="value.id" v-model="paymentTerms" />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs>

    <v-row v-if="debug">
      <v-col cols="12">
        value:
        <code>{{ paymentTerms }}</code>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import Contents from "../../shared/contents/Contents";
import PaymentTerms from "../../shared/payment-terms/PaymentTerms.vue";
export default {
  name: "edit-brand-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },

  components: { BasicDialog, Contents, PaymentTerms },

  data() {
    return {
      debug: false,
      tab: null,
      name: this.value ? this.value.name : "",
      notInUse: this.value ? this.value.notInUse : false,
      paymentTerms: this.value ? this.value.paymentTerms : [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.name != "";
    },
    editorTitle() {
      return this.name != "" ? this.name : "Edit Brand";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.name = newVal.name;
        this.notInUse = newVal.notInUse;
        this.paymentTerms = [...newVal.paymentTerms];
      }
    },
  },

  methods: {
    onSave() {
      this.$emit("input", {
        name: this.name,
        id: this.value && this.value.id ? this.value.id : undefined,
        notInUse: this.notInUse,
        paymentTerms: this.paymentTerms,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/brands/EditBrandDialog.vue